import Vue from 'vue'
import VueRouter from 'vue-router'

import conf from '@/ddv2.library/configure'
import users from '@/store/users'
import masters from '@/store/DDMasters'
import store from '@/store'

Vue.use(VueRouter)

const routes = conf.ROUTE_SETTING
const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  console.log('router.beforeEach')
  if (to.meta.allowAnonymous) {
    next()
    return
  }

  store.dispatch('users/loadLoginInfo').then(() => {
    store.dispatch('DDMasters/restoreMasters').then(() => {
      if (users.state.loginInfo !== null) {
        const id = _getIdFromViewName(to)
        console.info('path transitions', { from, to, id })
        store.dispatch('system/setCurrentKinoId', { id })
        next()
      } else {
        next({ name: 'Login' })
      }
    })
  })
})

const _getIdFromViewName = function ({ matched }) {
  const list = masters.state.msyskino
  const matchedUrls = matched.map((m) => {
    return m.name
  })
  const result = list.find((l) => {
    console.log('_getIdFromUrl', l.viewNm)
    return matchedUrls.indexOf(l.viewNm) !== -1
  })
  console.log('Router._getIdFromUrl', list, matchedUrls, result)
  if (result === undefined) { return 0 }
  return result.id
}

export default router
